<template>
  <LoaderComponent :value="promise" class="template-residential-templates">
    <div class="template-residential-templates__description" v-html="value.description"></div>

    <div class="template-residential-templates__items">
      <router-link
        :to="{ name: 'Template', params: { id: item.id } }"
        class="template-residential-templates__item-card"
        v-for="(item, index) in data"
        :key="index"
      >
        <div
          class="template-residential-templates__item-card-image"
          :style="{
            backgroundImage: `url(${getThumbnail(item)})`,
          }"
        ></div>
        <div class="template-residential-templates__item-card-title">
          {{ item.name }}
        </div>
      </router-link>
    </div>
  </LoaderComponent>
</template>

<script>
import { ButtonComponent } from 'vue-elder-button'
import { getResidentialTemplates } from './api'
import { LoaderComponent } from 'vue-elder-loader'
import { path } from 'ramda'

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      data: null,
      promise: null,
    }
  },

  methods: {
    getThumbnail(item) {
      let match = (path(['media', 'cover'], item) || []).find(i => i.type.startsWith('image'))
      if (!match) return

      return match.url
    },

    fetch() {
      return (this.promise = getResidentialTemplates({
        ids: this.value.references,
      }).then(data => {
        this.data = data.ResidentialTemplates
        return data
      }))
    },
  },
  created() {
    this.fetch()
  },
  components: {
    ButtonComponent,
    LoaderComponent,
  },
}
</script>

<style lang="scss">
.template-residential-templates {
  &__description {
    line-height: 1.5;
    max-width: 800px;
  }

  &__items {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 2rem;
    margin-top: 2rem;
  }

  &__item-card {
    text-decoration: none;

    &-image {
      background-size: cover;
      background-position: center;
      width: 100%;
      @include aspect-ratio(4, 3);
    }

    &-title {
      margin-top: 1rem;
      font-weight: bold;
    }
  }
}
</style>
